import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Grid, Form, Button, Segment } from 'semantic-ui-react';
import { TextWidget } from '@plone/volto/components';
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  slot: { id: 'Slot', defaultMessage: 'Slot' },
  chapeu: { id: 'Chapeu', defaultMessage: 'Chapéu' },
  titulo: { id: 'Titulo', defaultMessage: 'Título' },
  link: { id: 'Link', defaultMessage: 'Link' },
  imagem: { id: 'Imagem', defaultMessage: 'Imagem' },
});

const SLOT_LABELS = {
  du1: 'Destaque superior 1',
  du2: 'Destaque superior 2',
  du3: 'Destaque superior 3',
  ef1: 'Destaque em foco 1',
  ef2: 'Destaque em foco 2',
  ef3: 'Destaque em foco 3',
};

const SLOT_ORDER = ['du1', 'du2', 'du3', 'ef1', 'ef2', 'ef3'];

const normalizeValue = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const DestaquesWidget = ({
  value,
  id,
  onChange,
  required,
  title,
  description,
  error,
}) => {
  const intl = useIntl();
  const [items, setItems] = useState(() => normalizeValue(value));

  useEffect(() => {
    setItems(normalizeValue(value));
  }, [value]);

  const handleChange = (newItems) => {
    setItems(newItems);
    onChange(id, JSON.stringify(newItems));
  };

  const onChangeItem = (index, field, fieldValue) => {
    const newItems = items.map((item, idx) =>
      idx === index ? { ...item, [field]: fieldValue } : item,
    );
    handleChange(newItems);
  };

  const ensureSlot = (slot) => {
    const exists = items.find((item) => item.slot === slot);
    if (!exists) {
      handleChange([
        ...items,
        { slot, chapeu: '', titulo: '', link: '', imagem: '' },
      ]);
    }
  };

  return (
    <div className="destaques-widget">
      <Form.Field inline id={id} error={error?.length > 0}>
        <Grid>
          <Grid.Row>
            <Grid.Column width="12">
              <div className="wrapper">
                <label htmlFor={id}>{title}</label>
              </div>
            </Grid.Column>
          </Grid.Row>
          {description && (
            <Grid.Row>
              <Grid.Column stretched width="12">
                <p className="help">{description}</p>
              </Grid.Column>
            </Grid.Row>
          )}
          <Grid.Row>
            <Grid.Column width="14">
              {SLOT_ORDER.map((slot) => {
                const item = items.find((i) => i.slot === slot);
                const idx = items.findIndex((i) => i.slot === slot);
                return (
                  <Segment key={slot} secondary style={{ marginBottom: 12 }}>
                    <strong>{SLOT_LABELS[slot] || slot}</strong>
                    {idx === -1 ? (
                      <div style={{ marginTop: 8 }}>
                        <Button
                          size="tiny"
                          icon="plus"
                          content="Adicionar"
                          onClick={() => ensureSlot(slot)}
                        />
                      </div>
                    ) : (
                      <div style={{ marginTop: 8 }}>
                        <input
                          type="hidden"
                          name={`${id}-${slot}-slot`}
                          value={slot}
                        />
                        <TextWidget
                          id={`${id}-${slot}-chapeu`}
                          title={intl.formatMessage(messages.chapeu)}
                          description=""
                          required={false}
                          value={item.chapeu || ''}
                          onChange={(fieldId, val) =>
                            onChangeItem(
                              idx,
                              'chapeu',
                              typeof val === 'string' ? val : '',
                            )
                          }
                        />
                        <TextWidget
                          id={`${id}-${slot}-titulo`}
                          title={intl.formatMessage(messages.titulo)}
                          description=""
                          required={false}
                          value={item.titulo || ''}
                          onChange={(fieldId, val) =>
                            onChangeItem(
                              idx,
                              'titulo',
                              typeof val === 'string' ? val : '',
                            )
                          }
                        />
                        <TextWidget
                          id={`${id}-${slot}-link`}
                          title={intl.formatMessage(messages.link)}
                          description=""
                          required={false}
                          value={item.link || ''}
                          onChange={(fieldId, val) =>
                            onChangeItem(
                              idx,
                              'link',
                              typeof val === 'string' ? val : '',
                            )
                          }
                        />
                        <TextWidget
                          id={`${id}-${slot}-imagem`}
                          title={intl.formatMessage(messages.imagem)}
                          description=""
                          required={false}
                          value={item.imagem || ''}
                          onChange={(fieldId, val) =>
                            onChangeItem(
                              idx,
                              'imagem',
                              typeof val === 'string' ? val : '',
                            )
                          }
                        />
                      </div>
                    )}
                  </Segment>
                );
              })}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form.Field>
    </div>
  );
};

DestaquesWidget.defaultProps = {
  error: [],
};

export default DestaquesWidget;
